import React from 'react';
import OauthButton, { OauthAuthMode } from './OauthButton';
import { shouldShowMicrosoftButtonGroup } from '../util/microsoftCookie';

export interface SocialOauthButtonsProps {
    mode: OauthAuthMode;
    googleHref: string;
    microsoftHref: string;
    /** Hide G Suite (e.g. reseller client / agency). */
    hideGoogle?: boolean;
    /** Extra hide for Microsoft (cookie gate is applied internally). */
    hideMicrosoft?: boolean;
    hideShopify?: boolean;
    /** Match login Google/Microsoft click behavior (window.location). */
    forceNavigate?: boolean;
}

/**
 * Renders G Suite, Microsoft, and Shopify OAuth CTAs with shared markup.
 * Pair with <ShopifyAuthModal /> outside the credential form.
 */
const SocialOauthButtons: React.FC<SocialOauthButtonsProps> = ({
    mode,
    googleHref,
    microsoftHref,
    hideGoogle = false,
    hideMicrosoft = false,
    hideShopify = false,
    forceNavigate = false,
}) => {
    const showMicrosoft = shouldShowMicrosoftButtonGroup() && !hideMicrosoft;

    return (
        <>
            <OauthButton
                provider="google"
                mode={mode}
                href={googleHref}
                hidden={hideGoogle}
                forceNavigate={forceNavigate}
            />
            <OauthButton
                provider="microsoft"
                mode={mode}
                href={microsoftHref}
                hidden={!showMicrosoft}
                forceNavigate={forceNavigate}
            />
            <OauthButton provider="shopify" mode={mode} hidden={hideShopify} />
        </>
    );
};

/** Build Microsoft OAuth query from signup Google params (or a simple login URL). */
export function buildMicrosoftOauthHref(appURL: string, gsuiteParamsString?: string, microsoftParamsString?: string): string {
    if (microsoftParamsString) {
        return `${appURL || ''}oauth?${microsoftParamsString}`;
    }
    if (gsuiteParamsString) {
        if (/service=/.test(gsuiteParamsString)) {
            return `${appURL || ''}oauth?${gsuiteParamsString.replace(/service=[^&]*/, 'service=microsoft')}`;
        }
        return `${appURL || ''}oauth?service=microsoft&${gsuiteParamsString}`;
    }
    return `${appURL || ''}oauth?service=microsoft`;
}

export default SocialOauthButtons;
